import {useSuspenseQuery} from "@tanstack/react-query";

import {getLeadQueryOptions} from "./get-lead.query-options";

export function useGetLead(id: string, includeDeleted = false) {
  return useSuspenseQuery(getLeadQueryOptions(id, includeDeleted));
}
